import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormTextField } from '@grupo-constant/next-dtype/form';
import { INTEGER_COLUMN_URI, REAL_COLUMN_URI } from '@grupo-constant/next-dtype/types';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'complex-total-field-component',
    templateUrl: './complex-total-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeComplexTotalFieldComponent implements DTypeFormFieldComponent {


    @Input() field: DTypeFormTextField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    validTypes = [
        INTEGER_COLUMN_URI,
        REAL_COLUMN_URI
    ];

    constructor() { }
}
